var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "dc_mypage" } },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c("h1", { staticStyle: { display: "none" } }, [_vm._v("マイページ")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("dd-sitemap", {
                  attrs: {
                    pageKey: _vm.pageKey,
                    pageList: _vm.pageList,
                    mapStyle: "topic_path"
                  }
                }),
                _vm._v(" "),
                _c("section", [
                  _c("h2", [_vm._v("アカウント管理")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mypage_list" }, [
                    _c("div", [
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              _vm.route("DcOrderHistoryList")
                            }
                          }
                        },
                        [_vm._v("ご注文履歴")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              _vm.route("DcUserAccount")
                            }
                          }
                        },
                        [_vm._v("アカウント情報")]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm.isCorpLogin
                  ? _c("section", [
                      _c("h2", [_vm._v("所属企業の管理")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mypage_list" }, [
                        _c("div", [
                          _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  _vm.route("DcUserManager")
                                }
                              }
                            },
                            [_vm._v("ユーザ管理")]
                          )
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("section", [
                  _c("div", { staticClass: "control_btn_area" }, [
                    _c(
                      "div",
                      {
                        staticClass: "detail_btn5",
                        on: {
                          click: function($event) {
                            _vm.logout()
                          }
                        }
                      },
                      [_vm._v("ログアウト")]
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer"),
      _vm._v(" "),
      _c("dd-loading-modal", { ref: "loadingModalRef" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d63d599", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d63d599","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcMyPage.vue
// module id = null
// module chunks = 